// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"1ef6b6fb76d6ca04ab35","147":"94793a177e3daf958498","251":"d6c55c60a19d1c2c70e2","265":"88cbfd9a071139a17262","352":"3d36249ee959d39d6c7e"}[chunkId] + ".js";
};